import React,{ useState ,useRef, useEffect} from 'react'
import { Button, CarouselContainer, Container, Content, ContentImg, Data, Desc, Dots, DotsWrapper, PortfolioTitle, Section, SlideArrow, Subtitle, Title } from './PortfolioStyles'
import { UilArrowRight,UilAngleRightB, UilAngleLeftB } from '@iconscout/react-unicons';
import { SliderData } from '../data/PortfolioData';
// import { UilStar, ,UilAngleRightB } from '@iconscout/react-unicons';

// ====make carousel====
// import Carousel from './carousel/Carousel';
// import  makeCarousel from 'react-reveal/makeCarousel';




function Portfolio() {
    const [slideIndex, setSlideIndex] = useState(0);

    const handleClick = (direction) =>{
        if(direction === "left"){
            setSlideIndex(slideIndex > 0 ? slideIndex - 1 : 2);
        }else{
            setSlideIndex(slideIndex < 2? slideIndex + 1 : 0);
        }
    }

    const handleDotClick = (dotNumber)=>{
        setSlideIndex(dotNumber - 1);
    }

    // const CarouselContainer = makeCarousel(Carousel);
    
    return (

        <Section className="portfolio-section">
           <Title>Portfolio</Title> 
           <Subtitle>Most recent work</Subtitle>

            <Container >
                <SlideArrow left onClick={()=>handleClick("left")}>
                    <UilAngleLeftB size="1.25rem"/>
                </SlideArrow> 
               <CarouselContainer slideIndex={slideIndex}>
                    {
                        
                        SliderData.map((slide, index) => {
                            return(
                             <div className="ContentWrapper" key={index}>
                                <Content  >
                    
                                        <ContentImg src={slide.image}/>
                                        
                                        <Data>
                                            <PortfolioTitle>{slide.title}</PortfolioTitle>
                                            <Desc>
                                                {slide.desc}
                                            </Desc>
                                            <Button to={{ pathname: slide.link }} target="_blank">
                                                View Site
                                                <UilArrowRight size="1.25rem" className="btn__icon"/>
                                            </Button>
                                        </Data> 
                              </Content>
                              </div>
                              
                            )
                        })
                        
                    }
                    </CarouselContainer>
                    <SlideArrow right onClick={()=>handleClick("right")}>
                        <UilAngleRightB size="1.25rem"/>
                    </SlideArrow>
                    <DotsWrapper>
                    {
                        [1,2,3].map(index =>(
                            <Dots key={index} index={index} slideIndex={slideIndex} onClick={()=>handleDotClick(index)} />
                        ))
                    }
                </DotsWrapper>
            </Container>
        </Section>
    )
}

export default Portfolio
